import updateCart from './update-popup-cart.js';
import { postData } from './fetch';

window.addEventListener('load', () => {
  const treasureBuyButtons = document.querySelectorAll('.treasure-buy-button');
  const treasureModifierInput = document.querySelectorAll(
    '.treasure-modifier-input',
  );

  if (treasureBuyButtons) {
    [].forEach.call(treasureBuyButtons, (button) => {
      button.addEventListener('click', async () => {
        const groupId = button.dataset.groupid;
        const modifierId = button.dataset.modifierid;
        const { price } = button.dataset;

        const modifiers = [
          {
            groupId,
            items: [
              {
                id: modifierId,
                quantity: 1,
              },
            ],
          },
        ];

        const body = {
          id: button.dataset.id,
          quantity: 1,
          modifiers: JSON.stringify(modifiers),
        };

        button.textContent = 'Загрузка...';
        button.classList.add('disabled');

        const response = await postData('/cart', body);

        if (response) {
          if (json.statusCode === 200) {
            button.classList.remove('disabled');
            button.textContent = `В корзину за ${price} ₽`;

            updateCart(json.data, json.data.additional);
          } else {
            button.classList.remove('disabled');
            button.textContent = `В корзину за ${price} ₽`;
          }
        }
      });
    });
  }

  if (treasureModifierInput) {
    [].forEach.call(treasureModifierInput, (input) => {
      input.addEventListener('click', () => {
        const parentElement = input.closest('.treasure-popup-wrapper');

        if (parentElement) {
          const buyButton = parentElement.querySelector('.treasure-buy-button');

          if (buyButton) {
            buyButton.dataset.groupid = input.dataset.groupid;
            buyButton.dataset.modifierid = input.value;

            buyButton.classList.remove('disabled');
          }
        }
      });
    });
  }
});
